import React, {useEffect, useState} from "react";
import {DatePicker, Form, Input, InputNumber, Select, Switch} from 'antd';
import DataType from "../../constants/DataType";
import api from "../../api/api";
import moment from "moment";
import {useThemeSelector} from "../../redux/reducers/themeReducer";

const inputStyle = { /* borderRadius: 6 */};
const FormInput = ({label, name, placeholder, required, rules, tooltip, icon, type, options, url, displayColumn, disabled, disablePast, readOnly,
                   min, max // for InputNumber
                   }) => {
    const [optionsLoadedFromUrl, setOptionsLoadedFromUrl] = useState([]);
    const {darkMode} = useThemeSelector();

    useEffect(async () => {
        if (url) {
            const { data } = await api.get(url);
            setOptionsLoadedFromUrl(data)
        }
    }, [url]);
    
    const commonProps = {style: inputStyle, prefix: icon, placeholder: placeholder, disabled: disabled, readOnly: readOnly, type};

    const renderInput = () => {
        switch (type) {
            case DataType.INT:
            case DataType.DOUBLE:
                return <InputNumber {...commonProps} min={min} max={max} />;
            case DataType.DATE_TIME:
            case DataType.DATE:
                return <DatePicker disabledDate={current => {
                    // Can not select days before today and today
                    return disablePast && current && current < moment().endOf('day');
                }} style={{width: '100%'}} dropdownClassName={darkMode && 'dark-mode'}/>;
            case DataType.BOOLEAN:
                return <Switch/>;
            case DataType.TEXTAREA:
                return <Input.TextArea {...commonProps}/>;
            case DataType.PASSWORD:
                return <Input.Password {...commonProps}/>;
            case DataType.SELECT:
                return <Select showSearch allowClear style={{width: '100%'}} placeholder={"Select " + label}
                               required={required}
                               disabled={disabled}
                               dropdownClassName={darkMode && 'dark-mode'}
                               optionFilterProp="children"
                               >
                    {
                        (options ? options : optionsLoadedFromUrl).map(option => (
                            <Select.Option key={option.id} value={option.id}>{option[displayColumn] || option.value}</Select.Option>))
                    }
                </Select>;
            case DataType.MULTI_SELECT:
                return <Select mode="multiple" showSearch allowClear style={{width: '100%'}} placeholder={"Select " + label}
                               required={required}
                               disabled={disabled}
                               dropdownClassName={darkMode && 'dark-mode'}
                               optionFilterProp="children"
                               >
                    {
                        options.map(option => (
                            <Select.Option key={option.id} value={option.id}>{option.value}</Select.Option>))
                    }
                </Select>;
            default:
                return <Input {...commonProps}/>;
        }
    };

    return <Form.Item
        readOnly={disabled}
        label={label}
        name={name}
        rules={rules}
        tooltip={tooltip}
    >
        {renderInput()}
    </Form.Item>
};

export default FormInput;